import { useState } from 'react';
import { Stack, TextField } from '@mui/material';

import { DistrictInput } from '../../../shared/DistrictInput';
import { LocationInput } from '../../../shared/LocationInput';
import { PackInput } from '../../../shared/PackInput';
import { Action } from '../../model/components/ActionButton';

import { assertUnreachable } from '../../../utils/assert';

export interface ActionInputProps {
    value: Action;
    onChange?: (action: Action) => void;
}
export const ActionInput = ({ value, onChange }: ActionInputProps) => {
    if (value.$type === 'OpenShop') {
        return (
            <div>
                <PackInput
                    value={value.packId}
                    onChange={(packId) => onChange?.({ ...value, packId })}
                />
            </div>
        );
    }
    if (value.$type === 'OpenLocation') {
        const [cameraInput, setCameraInput] = useState(
            value.cameraPosition !== undefined
                ? String(value.cameraPosition)
                : '',
        );
        return (
            <Stack spacing={1}>
                <LocationInput
                    value={value.locationName}
                    onChange={(locationName) => {
                        onChange?.({
                            ...value,
                            locationName: locationName ?? '',
                        });
                    }}
                />
                <div>
                    <TextField
                        label="Camera Position"
                        value={cameraInput}
                        type="number"
                        onChange={(e) => {
                            const str = e.target.value;
                            setCameraInput(str);

                            if (
                                /^-?\d*$/.test(str) &&
                                str !== '' &&
                                str !== '-'
                            ) {
                                onChange?.({
                                    ...value,
                                    cameraPosition: Number(str),
                                });
                            } else if (str === '' || str === '-') {
                                onChange?.({
                                    ...value,
                                    cameraPosition: undefined,
                                });
                            }
                        }}
                    />
                </div>
            </Stack>
        );
    }
    if (value.$type === 'OpenDistrict') {
        return (
            <div>
                <DistrictInput
                    value={value.districtName}
                    onChange={(districtName) =>
                        onChange?.({
                            ...value,
                            districtName: districtName ?? '',
                        })
                    }
                />
            </div>
        );
    }
    if (value.$type === 'OpenCharacterCreator') {
        return (
            <div>
                <p>Character Creator</p>
            </div>
        );
    }
    if (value.$type === 'OpenOutfitDesigner') {
        return (
            <div>
                <p>Outfit Designer</p>
            </div>
        );
    }
    if (value.$type === 'OpenCEX') {
        return (
            <div>
                <p>Character Expression</p>
            </div>
        );
    }

    if (value.$type === 'OpenPortal') {
        return (
            <div>
                <p>Open Portal</p>
            </div>
        );
    }

    if (value.$type === 'OpenInStore') {
        return (
            <div>
                <p>Open In Store</p>
            </div>
        );
    }

    throw assertUnreachable(value);
};
